import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20" aria-labelledby="cta-heading">
      <div className="w-full px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2
            id="cta-heading"
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4"
          >
            还没吃够？
          </h2>
          <p className="text-base md:text-lg text-foreground-600 mb-8">
            订阅我们的每日猛料推送，第一时间获取最新吃瓜视频内容，不错过任何一个大瓜！
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/category/chigua-remen"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-foreground-950 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              浏览更多
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3.5 border border-background-300 text-foreground-700 font-medium text-sm rounded-full hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="relative h-40 md:h-56 overflow-hidden rounded-xl">
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-transparent to-background-50 z-10"></div>
          <div className="flex gap-4 animate-scroll">
            {[
              'ri-fire-line', 'ri-star-line', 'ri-heart-line', 'ri-flashlight-line',
              'ri-thumb-up-line', 'ri-emotion-happy-line', 'ri-live-line', 'ri-chat-smile-2-line',
            ].map((icon, i) => (
              <div
                key={i}
                className="w-20 h-20 md:w-28 md:h-28 rounded-2xl bg-background-100 flex items-center justify-center flex-shrink-0"
              >
                <i className={`${icon} text-3xl md:text-4xl text-primary-500/60`}></i>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}